export default class SubscribersController {
  constructor(NewsletterDataProvider) {
    "ngInject"
    this.NewsletterDataProvider = NewsletterDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getSubscribers();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getSubscribers();
  }

  getSubscribers() {
    let
      vm = this;
    let data = {};
    let searchData = {};
    searchData.name = vm.name;
    searchData.email = vm.email;
    data.searchData = searchData;
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.NewsletterDataProvider.getSubscribers(data, searchData).then(function (result) {
      vm.subscribers = result.data;
      vm.subscribersTotal = result.total;
      vm.selectall = false;
    });
  }

  removeSubscriber(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.NewsletterDataProvider.removeSubscriber(id).then(function (res) {
      vm.getSubscribers();
    })
  }

  clearFilter() {
    this.name = '';
    this.code = '';
    this.type = '';
    this.price_from = '';
    this.price_to = '';
    this.used_count = '';
    this.status = '';
    this.getSubscribers();
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/components/subscribers/controller.js
 **/